import { i as c } from "./lit-element-6iugfgmM.js";
const s = c`
    
`, i = c`
    .spectrum-UIIcon-Checkmark50{--spectrum-icon-size:var(--system-ui-icon-checkmark-50-icon-size)}.spectrum-UIIcon-Checkmark75{--spectrum-icon-size:var(--system-ui-icon-checkmark-75-icon-size)}.spectrum-UIIcon-Checkmark100{--spectrum-icon-size:var(--system-ui-icon-checkmark-100-icon-size)}.spectrum-UIIcon-Checkmark200{--spectrum-icon-size:var(--system-ui-icon-checkmark-200-icon-size)}.spectrum-UIIcon-Checkmark300{--spectrum-icon-size:var(--system-ui-icon-checkmark-300-icon-size)}.spectrum-UIIcon-Checkmark400{--spectrum-icon-size:var(--system-ui-icon-checkmark-400-icon-size)}.spectrum-UIIcon-Checkmark500{--spectrum-icon-size:var(--system-ui-icon-checkmark-500-icon-size)}.spectrum-UIIcon-Checkmark600{--spectrum-icon-size:var(--system-ui-icon-checkmark-600-icon-size)}
`;
export {
  i as e,
  s as t
};
//# sourceMappingURL=icon-checkmark-overrides.css-WghIH2FR.js.map
